export default {
    accountLogoAnimationDone: false,
    accountError: null,
    accountTypes: [{
        label: 'Architect',
        value: 1
    }, {
        label: 'Home seeker',
        value: 2
    }, {
        label: 'Engineer',
        value: 3
    }, {
        label: 'Interior designer',
        value: 4
    }, {
        label: 'Contractor',
        value: 5
    }, {
        label: 'Company',
        value: 6
    }],
    user: {},
    userLoading: false,
    isLogedIn: false,
    userUpdating: false
}